// Hook do dialog generico de movimento (Sangria ou Suprimento).
// Encapsula:
//   - estado de abertura
//   - campos do formulario (valor, observacao)
//   - reset automatico ao fechar
//
// Uso:
//   const sangria = useMovimentoDialog();
//   const suprimento = useMovimentoDialog();
//
//   <Button onClick={sangria.open}>Sangria</Button>
//   <MovimentoDialog open={sangria.isOpen} onClose={sangria.close}
//                    valor={sangria.valor} ... />

import { useCallback, useState } from "react";

export function useMovimentoDialog() {
  const [isOpen, setIsOpen] = useState(false);
  const [valor, setValor] = useState(0);
  const [observacao, setObservacao] = useState("");

  const open = useCallback(() => {
    setValor(0);
    setObservacao("");
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setValor(0);
    setObservacao("");
  }, []);

  return { isOpen, valor, observacao, setValor, setObservacao, open, close, setIsOpen };
}
